<template>
  <tabela-log
    :carregar="carregar"
    :colunas="colunasListagem"
  />
</template>

<style lang="scss">
</style>

<script>
import api from '@/app-modulo/comuns/log/shared/services/api'

export default {
  name: 'Log',
  components: {
    TabelaLog: () => import('@/app-modulo/comuns/log/shared/components/tabela-log/TabelaLog.vue'),
  },
  props: {
  },
  data() {
    return {
      dadosTabela: [],
      colunasListagem: [
        { label: 'Registro', field: 'descricaoRegistro' },
        { label: 'Recurso', field: 'recurso' },
        { label: 'Evento', field: 'tipo' },
        {
          label: 'Início',
          field: 'inicio',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSS',
          dateOutputFormat: 'dd/MM/yyyy HH:mm:ss',
        },
        {
          label: 'Fim',
          field: 'fim',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSSSSS',
          dateOutputFormat: 'dd/MM/yyyy HH:mm:ss',
        },
        { label: 'Usuário', field: 'usuario' },
      ],
    }
  },
  created() {
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getLogsPaginados(page, pageSize, filtros)
    },
  },
}
</script>
